// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"ed0ed3c5","73":"925da7c6","110":"767d0d25","355":"ec7c620c","437":"5df5c154","513":"7b7187e3","595":"cb7de626","900":"868c9f0b","931":"50a6b171"}[chunkId] + ".chunk.js";
};